import React, { useCallback, useEffect, useState } from "react";
import { ProductCarousel } from "../../../component/productCarousel/ProductCarousel";
import classes from "./spareDetail.module.css";
import { SpareColors } from "../spareColor/SpareColors";
import { SparePrice } from "../sparePrice/SparePrice";
import { SpareHighlights } from "../spareHighlights/SpareHighlights";
import { SpareOffers } from "../spareOffers/SpareOffers";
import { validateImages } from "../../../utils/imageValidator";
import dummy from "../../../assets/dummyPreview.png";
import Cookies from "js-cookie";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import useCartListDeleteItemMutation from "../../../tanstack-query/cartList/useCartListDeleteItemMutation";
import { toast } from "react-toastify";
import { CustomTable } from "../../customTable/CustomTable";
import { sparesDetailColumnsConfig } from "./spareDetailColumnConfig";
import { formatNumber } from "../../../utils/formatNumber";

const dummyArray = [dummy];

export const SpareDetail = ({
  spareData,
  // prices,
  // colors,
  // descriptions,
  // color,
  // spareData,
  // partName,
  // onColorSelect,
  // onAddToCart,
  // cart_status,
  // wishlist_status,
  // onWishList,
}) => {
  // const [searchParams, setSearchParams] = useSearchParams();
  const [validationResults, setValidationResults] = useState({});
  // const navigate = useNavigate();
  // const { mutateAsync: deleteItem } = useCartListDeleteItemMutation();
  // const handleRemove = useCallback(async () => {
  //   const { category_id, master_product_id, request_id } = spareData;

  //   const data = {
  //     category_id,
  //     ...(category_id === 5 ? { request_id } : { master_product_id }),
  //   };

  //   try {
  //     const response = await deleteItem(data);
  //     toast.success(response.message.displayMessage);
  //   } catch (error) {
  //     toast.error(
  //       error.response?.data?.message?.displayMessage || "Delete failed."
  //     );
  //   }
  // }, [spareData, deleteItem]);

  // Function to check if an image URL is valid
  const checkImageUrl = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true); // Image loaded successfully
      img.onerror = () => resolve(false); // Error loading image
      img.src = url;
    });
  };

  console.log("spareDetail", spareData);

  // Function to validate all image URLs
const validateImages = useCallback(async (images) => {
  if (!Array.isArray(images)) return; // prevents error
  const results = {};
  for (const url of images) {
    console.log("url:", url.image_url);
    results[url.image_url] = await checkImageUrl(url.image_url);
  }
  setValidationResults(results);
}, []);


  useEffect(() => {
  validateImages(spareData?.images || []);
}, [spareData?.images, validateImages]);

  console.log(validationResults);
  console.log("sparesDetail ", spareData?.data?.data);

  // const handleBrandFilter = () => {
  //   const brand = spareData?.data?.data?.brand;
  //   if (brand) {
  //     const params = new URLSearchParams();
  //     params.set("brand", brand);
  //     navigate(`/spares?${params.toString()}`);
  //   }
  // };

  // const handleModelFilter = () => {
  //   const model = spareData?.data?.data?.model;
  //   if (model) {
  //     const params = new URLSearchParams();
  //     params.set("model", model);
  //     navigate(`/spares?${params.toString()}`);
  //   }
  // };

  const imageArray = Object.keys(validationResults).filter(
    (key) => validationResults[key] === true
  );
  console.log(imageArray);
  const authToken = Cookies.get("authToken");
  const header = false;

  const prices = {
    originalPrice: formatNumber(spareData?.original_price),
    discountedPrice: formatNumber(spareData?.discounted_price),
    discountPercentage: spareData?.discount_percentage,
    quantity: spareData?.cart_count,
  };
  const getDescriptions = (obj) => {
    if (!obj || typeof obj !== "object") return [];

    return Object.keys(obj)
      .filter((key) => key.startsWith("description_") && obj[key])
      .sort((a, b) => {
        // Ensure description_1, description_2... are sorted numerically
        return parseInt(a.split("_")[1], 10) - parseInt(b.split("_")[1], 10);
      })
      .map((key) => obj[key]);
  };
  return (
    <div className={classes.box}>
      <div className={classes.box__info__wrapper}>
        <div className={classes.box__info}>
          <div className={classes.box__intro}>
            {/* {authToken ? (
              <span
                className={
                  wishlist_status === 1
                    ? classes.box__info__fav__active
                    : classes.box__info__fav
                }
                onClick={onWishList}
              />
            ) : null} */}

            <ProductCarousel
              imageData={imageArray.length < 1 ? dummyArray : imageArray}
            />
            <div className={classes.box__spareName}>
              <h1 className={classes.box__spareName__title}>
                {spareData?.part_name}
              </h1>
              <h2 className={classes.box__spareName__subtitle}>New</h2>
              {/* <hr className={classes.box__item__divider} /> */}
            </div>
          </div>
        </div>
        <div className={classes.box__info}>
          <SpareColors
            // colors={colors}
            color={spareData?.color}
            // onColorSelect={onColorSelect}
          />
          <SparePrice prices={prices} />

          <SpareHighlights highlights={getDescriptions(spareData)} />
        </div>
      </div>
      <hr className={classes.box__divider__tab} />

      <div className={classes.box__info__wrapper}>
        <div className={classes.box__productDetails}>
          <h2 className={classes.box__productDetails__head}>Product details</h2>
          {spareData?.product_details?.length > 0 ? (
            <div className={classes.box__productDetails__points}>
              {spareData?.product_details.map((detail, index) => (
                <div className={classes.box__productDetails__point} key={index}>
                  <span
                    className={classes.box__productDetails__point__bullet}
                  />
                  <p className={classes.box__productDetails__point__para}>
                    {detail}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <h3 className={classes.box__productDetails__empty}>
              Details are currently unavailable.
            </h3>
          )}

          {/* <hr className={classes.box__divider} /> */}
        </div>
        <div className={classes.box__productDetails}>
          <h2 className={classes.box__productDetails__head}>Specifications</h2>

          <CustomTable
            data={spareData?.specifications}
            columns={sparesDetailColumnsConfig(header)}
            header={header}
          />

          {/* <hr className={classes.box__divider} /> */}
        </div>
      </div>
      {/* <div className={classes.box__info__wrapper}>
        <button
          className={classes.box__filter__btn}
          onClick={handleBrandFilter}
        >{`Explore more spares for ${spareData?.data?.data?.brand}`}</button>
        <button
          className={classes.box__filter__btn}
          onClick={handleModelFilter}
        >{`Explore more spares for ${spareData?.data?.data?.model}`}</button>
      </div> */}
    </div>
  );
};